import { useState, useEffect } from 'react';
import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import { createLogger } from '../utils/logger';

const logger = createLogger('useProductImage');

/**
 * Resolve a Firebase Storage path to a download URL.
 * @param {string|undefined|null} imagePath
 */
export function useProductImage(imagePath) {
  const [imageUrl, setImageUrl] = useState('');
  const [loading, setLoading] = useState(false);

  const isBlob =
    imagePath && typeof imagePath === 'string' && imagePath.startsWith('blob:');
  const isValidPath =
    imagePath && typeof imagePath === 'string' && !isBlob;

  useEffect(() => {
    if (!isValidPath) {
      setImageUrl('');
      setLoading(false);
      if (imagePath && isBlob) {
        logger.warn('[useProductImage] Blob URL cannot be used as Storage path:', imagePath);
      } else if (imagePath && !isValidPath) {
        logger.warn('[useProductImage] Invalid imagePath:', imagePath);
      }
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    const storage = getStorage();
    const imageRef = ref(storage, imagePath);

    getDownloadURL(imageRef)
      .then((url) => {
        if (!cancelled) setImageUrl(url);
      })
      .catch((err) => {
        logger.error('[useProductImage] Error fetching URL for path:', imagePath, err);
        if (!cancelled) setImageUrl('');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [imagePath, isValidPath, isBlob]);

  return { imageUrl, loading, isBlob, isValidPath };
}
